import { render } from "./CreateReturn.vue?vue&type=template&id=c5d8e272"
import script from "./CreateReturn.vue?vue&type=script&lang=js"
export * from "./CreateReturn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__